import store from '@/stores/store'

const Item = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Items')
const ItemIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/items/Index')
const ItemShow = () => import(/* webpackChunkName: "admin" */ '@/components/admin/items/Show')

export default {
  children: [
    {
      component: ItemIndex,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {name: 'Items'},
        ]
      },
      path: '/'
    },
    {
      component: ItemShow,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {link: '/admin/items', name: 'Items'},
          {dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show'},
        ]
      },
      path: ':id',
      props: true
    },
  ],
  component: Item,
  path: 'items',
}
